import axios from 'axios';
class IDService {

  async generateNewID(onUploadProgress, dataDir, url) {
    //let formData = new FormData();
    let formData = {}
    formData["data_dir"] = 'pub'//dataDir

    return await axios.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      },
      onUploadProgress
    });
  }

  async getIDs(onUploadProgress, url) {
    let formData = new FormData();
    //formData.append("data_dir",dataDir)

      let requestData = [ {chr:'1'}];
            return axios.post(url, requestData)
            return response
         }

  async getMTBConferences(onUploadProgress,url ) {
    return axios.get(url)
  }

  async getMTBData(onUploadProgress, url) {
    let formData = new FormData();
    return axios.get(url)
  }

    async getIDFeatureData(onUploadProgress, url,pid) {
        let formData = new FormData();
        //formData.append("data_dir",dataDir)
        formData.append("pid", pid)
        //alert(url)
        url = url + "?pid=" +pid

        //return axios.get(url, formData)
        //return response
        return axios.get(url)
    }
}

export default new IDService();
